export const n2sDataSource = [
  {
    key: "1",
    name: "key",
    req_opt: "Required",
    type: "String",
    description: (
      <>
        <p>
          Authorization key, required parameter to access Native To Search Feed
          Report API. Contain only digits and letters. You may obtain your
          authorization key from your personal manager.
        </p>
        <p>
          Example: <b>UQlXSEHTd2kWbVY3n0ETLx3v</b>
        </p>
      </>
    ),
  },
  {
    key: "2",
    name: "resType",
    req_opt: "Required",
    type: "String",
    description: (
      <p>
        This parameter is used to specify the response type. Available values
        are <b>table</b> (json) and <b>csv</b>.
      </p>
    ),
  },
  {
    key: "3",
    name: "columns",
    req_opt: "Required",
    type: "String",
    description: (
      <>
        <p>
          Value is a string that can take multiple values separated by a comma.
          In this field you should pass <b>labels</b> that you expect in
          response. Predefined labels that can be used are:
        </p>
        <ul>
          <li>- date,</li>
          <li>- search_channel,</li>
          <li>- campaign_id,</li>
          <li>- country,</li>
          <li>- total_searches,</li>
          <li>- monetized_searches,</li>
          <li>- clicks,</li>
          <li>- provider,</li>
          <li>- rpc,</li>
          <li>- rpm,</li>
          <li>- ctr,</li>
          <li>- revenue,</li>
          <li>- monetized_rpm,</li>
          <li>- ad_coverage,</li>
          <li>- revenue</li>
        </ul>
      </>
    ),
  },
  {
    key: "4",
    name: "date_from",
    req_opt: "Required",
    type: "String",
    description: "yyyy-mm-dd",
  },
  {
    key: "5",
    name: "date_to",
    req_opt: "Required",
    type: "String",
    description: "yyyy-mm-dd",
  },
  {
    key: "6",
    name: "limit",
    req_opt: "Optional",
    type: "Integer",
    description:
      "Limit shows you the number of rows which will be shown in the API response. By default limit is 30.",
  },
  {
    key: "7",
    name: "offset",
    req_opt: "Optional",
    type: "Integer",
    description:
      "Offset determines how many rows will be skipped before the data is displayed. Default is 0.",
  },
  {
    key: "8",
    name: "ordering",
    req_opt: "Optional",
    type: "String",
    description: (
      <div>
        <p>
          For ordering you can use one of the labels from the columns list. For
          descending just use column name, e.g. revenue, and for ascending use -
          symbol, e.g. -revenue.
        </p>
      </div>
    ),
  },
];

export const n2sColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Req/Opt",
    dataIndex: "req_opt",
    key: "req_opt",
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: "60%",
  },
];

export const n2sResponse = `{
  "total": [
      {
          "date": 23,
          "country": 50,
          "monetized_searches": 83003
      }
  ],
  "table": [
      {
          "date": 20210510,
          "country": "US",
          "monetized_searches": 344
      },
      {
          "date": 20210510,
          "country": "US",
          "monetized_searches": 606
      },
      {
          "date": 20210510,
          "country": "GB",
          "monetized_searches": 134
      },
      {
          "date": 20210510,
          "country": "US",
          "monetized_searches": 745
      },
      {
          "date": 20210510,
          "country": "US",
          "monetized_searches": 690
      },
      {
          "date": 20210510,
          "country": "DE",
          "monetized_searches": 505
      },
      {
          "date": 20210510,
          "country": "DE",
          "monetized_searches": 107
      },
      {
          "date": 20210510,
          "country": "US",
          "monetized_searches": 532
      },
      {
          "date": 20210510,
          "country": "US",
          "monetized_searches": 623
      },
      {
          "date": 20210510,
          "country": "DE",
          "monetized_searches": 705
      }
  ],
  "rows": 248,
  "missing_dates": []
}`;
